import classnames from 'classnames';

import { isChinaProvince } from '../province';

const getAddress = ({ country, province, city }) => {
  if (!country && !province && !city) {
    return '';
  }

  if ((country && !province && !city) || (country && province && !city && country === province)) {
    return classnames({ [country]: country }).replace(/\s+/g, '');
  }

  const myCountry = `${isChinaProvince(String(province)) || country === '中国' ? '' : country}`;
  const myProvince = `${province && province !== country && province !== city ? province : ''}`;

  return classnames({ [country]: myCountry }, { [province]: myProvince }, { [city]: city }).replace(/\s+/g, '');
};

export { getAddress };
